/* Lichtgrün — mobile nav drawer open/close (drawer/overlay moved to body so they overlay the full viewport) */
(function () {
  function init() {
    var nav = document.querySelector('.lg-mobnav');
    if (!nav) return;
    var toggle = nav.querySelector('.lg-mobnav__toggle');
    var overlay = nav.querySelector('.lg-mobnav__overlay');
    var drawer = nav.querySelector('.lg-mobnav__drawer');
    if (!toggle || !drawer) return;
    var closeBtn = drawer.querySelector('.lg-mobnav__close');
    if (overlay) document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    function open() {
      if (overlay) overlay.hidden = false;
      drawer.hidden = false;
      requestAnimationFrame(function () {
        nav.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        drawer.classList.add('is-open');
      });
      document.body.classList.add('lg-mobnav-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      nav.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      document.body.classList.remove('lg-mobnav-open');
      toggle.setAttribute('aria-expanded', 'false');
      setTimeout(function () {
        if (!drawer.classList.contains('is-open')) { if (overlay) overlay.hidden = true; drawer.hidden = true; }
      }, 320);
    }

    toggle.addEventListener('click', function () { drawer.classList.contains('is-open') ? close() : open(); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
